import { Slide } from "@mui/material";
import { ReactElement } from "react";

type Props = {
  children: ReactElement;
  open: boolean;
  direction?: "up" | "left" | "right" | "down";
  timeout?: number;
  onTransitionStart?: () => void;
  onTransitionEnd?: () => void;
};

const SySlide = (props: Props) => {
  const {
    children,
    open,
    direction,
    timeout,
    onTransitionEnd,
    onTransitionStart,
  } = props;
  return (
    <Slide
      in={open}
      direction={direction}
      timeout={timeout}
      mountOnEnter
      unmountOnExit
      onEnter={onTransitionStart}
      onExited={onTransitionEnd}
    >
      {children}
    </Slide>
  );
};

export default SySlide;
